import {connect} from 'react-redux';
import {formValueSelector} from 'redux-form';
import SquadChangeModal from './SquadChangeModal.jsx';
import {
  validateCaptainManageSquadChangeForm,
  handleSquadChangeSave,
  handleSquadChangeCancel,
  handleSquadDateChanged,
  handleSquadTimeChanged
} from './actions';

const selector = formValueSelector('captainManageSquadChangeForm');

const mapStateToProps = state => ({
  validate: validateCaptainManageSquadChangeForm,
  visible: state.registration.manage.showSquadChangeModal,
  ...selector(state, 
    'childAvailableSquads',
    'childSquadDateTime',
    'childEventName',
    'childSquadDateTime',
    'childrenEntries',
    'entryId',
    'isBundledChild',
    'parentAvailableSquads',
    'parentEventName',
    'parentSquadDateTime',
    'startDate',
    'endDate'
  )
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(handleSquadChangeSave(data)),
  onCancel: () => dispatch(handleSquadChangeCancel()),
  onDateChange: (entryId, date) => dispatch(handleSquadDateChanged(entryId, date)),
  onTimeChange: (entryId, parentSquadId) => dispatch(handleSquadTimeChanged(entryId, parentSquadId))
});

export default connect(mapStateToProps, mapDispatchToProps)(SquadChangeModal);



// WEBPACK FOOTER //
// ./src/features/registration/manage/SquadChangeModalContainer.jsx